import { UserOutlined } from "@ant-design/icons";
import { useLazyQuery, useMutation } from "@apollo/client";
import { Avatar, Col, Pagination, Row, Spin } from "antd";
import GoogleMapReact from "google-map-react";
import React from "react";
import { FaSearch } from "react-icons/fa";
import { FcCancel } from "react-icons/fc";
import { IoMegaphone } from "react-icons/io5";
import { TiMessages } from "react-icons/ti";
import countryList from "react-select-country-list";
import styled from "styled-components";
import useSupercluster from "use-supercluster";
import {
  GET_REQUESTLIST,
  MEET_PEOPLE,
  REQUEST_TO_CHAT,
} from "../../app/apollo/index";
import { useAppSelector } from "../../app/hooks";
import { LoggerButton } from "../../globalComponents/Button";
import { DropDown } from "../../globalComponents/DropDown";
import {
  BigContentContainer,
  FilterButton,
  FilterContainer,
  Label,
} from "../../globalComponents/globalStyle";
import { ModalComponent } from "../../globalComponents/Modal";
import { userInfo } from "../../globalComponents/slice/userDataSlice";
import { TextInput } from "../../globalComponents/TextInput";
import { NotificationAlert } from "../../utils/NotificationAlert";
import { StyledInput } from "../Post/style";
import { ClusterContainer, ModalContainer, UserImage, UserList } from "./Style";

const People: React.FC = (props: any, context: any) => {
  const mapRef = React.useRef();
  const [defaultCountry, setDefaultCountry] = React.useState();
  const [showMap, setShowMap] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [country, setCountry] = React.useState<any>("");
  const [loadingstate, setLoadingState] = React.useState(false);
  const [loadingRequestState, setLoadingRequestState] = React.useState(false);
  const [getPeople, getPeopleData] = useLazyQuery(MEET_PEOPLE);
  const [personInfo, setPersonInfo] = React.useState<any>();
  const [peopleList, setPeopleList] = React.useState<any>([]);
  const [currentPage, setCurrentPage] = React.useState<any>(1);
  const [allPages, setAllPages] = React.useState<any>();
  const [city, setCity] = React.useState<any>("");
  const [requestToChatWithUser] = useMutation(REQUEST_TO_CHAT);
  const [defaultZoom, setDefaultZoom] = React.useState<number>();
  const [people, setPeople] = React.useState([]);
  const [zoom, setZoom] = React.useState(10);
  const [bounds, setBounds] = React.useState<Array<any> | null>(null);
  const Marker: React.FC<any> = ({ children }) => (
    <ClusterContainer> {children}</ClusterContainer>
  );
  const options = React.useMemo(() => countryList().getData(), []);
  const [open, setOpen] = React.useState<boolean>(false);
  const userDetails = useAppSelector(userInfo);
  React.useEffect(() => {
    setDefaultCountry(userDetails?.currentCountry?.country);
  }, [userDetails]);
  React.useEffect(() => {
    handlePeopleSearch(defaultCountry, "", currentPage);
  }, [defaultCountry]);

  React.useEffect(() => {
    if (getPeopleData?.error) {
      setLoadingState(false);
      NotificationAlert("error", "Error occured", "Try Again");
    } else if (getPeopleData?.data?.meetPeople) {
      setLoadingState(false);
      setPeopleList(getPeopleData?.data?.meetPeople?.User);
      setAllPages(getPeopleData?.data?.meetPeople?.last_page);
    } else if (getPeopleData?.loading === true) {
      setLoadingState(true);
    }
  }, [getPeopleData]);

  const handlePeopleSearch = (country?: any, city?: any, current?: number) => {
    setPeopleList([]);
    if (city) {
      setDefaultZoom(50);
    }
    try {
      getPeople({
        variables: {
          byCountry: country,
          byCity: city,
          requestedPage: current,
        },
      });
    } catch (e) {
      NotificationAlert("error", "Error occured", "Try Again");
      console.log(e);
    }
  };
  const singlePerson = peopleList.map((person: any) => (
    <UserList>
      {console.log("person", person)}
      {person?.photolink ? (
        <img src={person?.photolink} alt={person?.firstname} />
      ) : (
        <Avatar size={{ xs: 50, xl: 60 }} icon={<UserOutlined />} />
      )}
      <div>
        <h1>
          {person?.firstname} {person?.lastname}
        </h1>
        <h2>{person?.email}</h2>
        <h2>
          currently in {person?.currentCountry?.country},
          {person?.currentCountry?.city}
        </h2>
      </div>
      {+person?.id !== +userDetails?.id && person?.canRequestToChat && (
        <h3
          onClick={() => {
            setOpen(true);
            setPersonInfo(person);
          }}
        >
          <TiMessages />
        </h3>
      )}
      {!person?.canRequestToChat && (
        <h3 style={{ cursor: "not-allowed" }}>
          <FcCancel />
        </h3>
      )}
    </UserList>
  ));
  console.log("user details", userDetails);
  console.log("getPeopleData", getPeopleData);
  const togglerChange = () => {
    setShowMap(!showMap);
  };
  const [getRequestList, getRequestData] = useLazyQuery(GET_REQUESTLIST);

  const sendRequest = async (id: number, message: String) => {
    setLoadingRequestState(true);
    try {
      const response = await requestToChatWithUser({
        refetchQueries: [
          {
            query: MEET_PEOPLE,
          },
        ],
        variables: {
          user_id: id,
          msg: message,
        },
      });
      if (response) {
        setLoadingRequestState(false);
        if (response?.data?.requestToChatWithUser?.success) {
          setOpen(false);
          getRequestList();
          NotificationAlert(
            "success",
            "Success",
            response?.data?.requestToChatWithUser?.msg
          );
        } else {
          NotificationAlert(
            "error",
            "Error",
            response?.data?.requestToChatWithUser?.msg
          );
        }
      }
    } catch (e) {
      setLoadingRequestState(false);
      NotificationAlert(
        "error",
        "Error occured",
        "Could not request.Try Again."
      );
    }
  };

  console.log("people  list", peopleList);
  const points = peopleList?.map((crime: any) => ({
    type: "Feature",
    properties: {
      photo: crime?.photolink,
      cluster: false,
      crimeId: crime?.id,
      info: {
        crime,
        // firstname: crime?.firstname,
        // lastname: crime?.lastname,
        // country: crime?.currentCountry?.country,
        // city: crime?.currentCountry?.city,
      },
      category: "anti-social", /// not needed
    },
    geometry: {
      type: "Point",
      coordinates: [
        parseFloat(crime.currentCountry.lng),
        parseFloat(crime.currentCountry.lat),
      ],
    }, // longitude latitude
  }));
  const { clusters } = useSupercluster<any>({
    points,
    bounds,
    zoom,
    options: { radius: 75, maxZoom: 15 },
  });
  console.log("the clusters", clusters);
  const ListComponent: any = <div>Some list goes in here</div>;
  const handleBackChange = () => {
    if (currentPage > 1) {
      handlePeopleSearch(country, city, currentPage - 1);
      setCurrentPage(currentPage - 1);
    }
  };
  const handleForwardChange = () => {
    if (currentPage < allPages) {
      handlePeopleSearch(country, city, currentPage + 1);
      setCurrentPage(currentPage + 1);
    }
  };
  function itemRender(current?: any, type?: any, originalElement?: any) {
    if (type === "prev") {
      return (
        <h5 style={{ color: "blue", margin: 0 }} onClick={handleBackChange}>
          Previous
        </h5>
      );
    }
    if (type === "next") {
      return (
        <h5 style={{ color: "blue", margin: 0 }} onClick={handleForwardChange}>
          Next
        </h5>
      );
    }
    return originalElement;
  }
  return (
    <BigContentContainer style={{ paddingBottom: "50px" }}>
      {/* <Toggler>
        <h3>{showMap ? "Show List" : "Show Map"}:</h3>{" "}
        <Switch
          size={"small"}
          style={{ background: `rgba(16, 171, 222, 0.5)` }}
          onChange={togglerChange}
        />
      </Toggler> */}
      <ModalComponent visible={open} onCancel={() => setOpen(false)}>
        <ModalContainer>
          <h3>Send message Request</h3>
          {personInfo?.photolink ? (
            <UserImage src={personInfo?.photolink} />
          ) : (
            <Avatar size={{ xs: 80 }} icon={<UserOutlined />} />
          )}
          <h4>
            Name:{" "}
            <span>
              {" "}
              {personInfo?.firstname} {personInfo?.lastname}
            </span>
          </h4>
          <h4>
            Location:{" "}
            <span>
              {" "}
              {personInfo?.currentCountry?.country},
              {personInfo?.currentCountry?.city}
            </span>
          </h4>
          <h4>
            Message:{" "}
            <span>
              <StyledInput
                onChange={(e) => setMessage(e.target.value)}
                autoSize={{ minRows: 3, maxRows: 3 }}
              />
            </span>{" "}
          </h4>
          <LoggerButton
            loading={loadingRequestState}
            text="Send Request"
            onClick={() => sendRequest(+personInfo?.id, message)}
          />
        </ModalContainer>
      </ModalComponent>
      <h1 className="title-bold" style={{ margin: 0 }}>
        Meet People
      </h1>
      <div className="title-regular">
        Locate people in your selected location
      </div>
      <Row
        style={{
          alignItems: "center",
          padding: "10px 0",
          justifyContent: "space-between",
        }}
      >
        <h3 className="title-medium">
          {peopleList?.length || 0} persons found
        </h3>
        <Row>
          <div style={{ width: "300px", marginRight: "15px" }}>
            <Label style={{ marginLeft: "-10px" }}>
              <h3 className="title-regular"> Country</h3>
            </Label>
            <DropDown
              values={options}
              onChange={(e) => setCountry(e.target.value)}
            />
          </div>
          <div style={{ width: "300px", marginRight: "15px" }}>
            <Label style={{ marginLeft: "-10px" }}>
              <h3 className="title-regular"> City</h3>
            </Label>
            <TextInput
              placeholder="Type city/state name here..."
              onChange={(e: any) => setCity(e.target.value)}
            />
          </div>
          <div style={{ margin: "auto", cursor: "pointer" }}>
            <FilterButton>
              <div>
                <FaSearch
                  size={27}
                  color="#3b72bb"
                  style={{ marginTop: "25px" }}
                  onClick={() => handlePeopleSearch(country, city, currentPage)}
                />
              </div>{" "}
              <button
                onClick={() => handlePeopleSearch(country, city, currentPage)}
              >
                Filter
              </button>
            </FilterButton>
          </div>
        </Row>
      </Row>
      {loadingstate && (
        <Row>
          <Text>loading... please wait</Text> <Spin />
        </Row>
      )}
      {peopleList?.length === 0 && !loadingstate && (
        <div style={{ width: "100%", display: "grid", placeItems: "center" }}>
          <IoMegaphone size={70} />
          <Text>Sorry, no match found</Text>
        </div>
      )}
      {peopleList.length > 0 && (
        <Row justify="space-between">
          <Col xs={{ span: 24 }} lg={{ span: 14 }}>
            {/* {showMap ? ( */}
            <FilterContainer>
              <GoogleMapReact
                // bootstrapURLKeys={{ key: "AIzaSyA5Rr4MGwQcEwDNCYyJ-w22-9pA_LyInlg" }}
                bootstrapURLKeys={{
                  key: process.env.REACT_APP_GOOGLE_KEY as string,
                }}
                center={{
                  lat:
                    peopleList.length > 0
                      ? Number(peopleList[0]?.currentCountry?.lat)
                      : Number(userDetails?.currentCountry?.lat),
                  lng:
                    peopleList.length > 0
                      ? Number(peopleList[0]?.currentCountry?.lng)
                      : Number(userDetails?.currentCountry?.lng),
                }}
                defaultCenter={{
                  lat:
                    peopleList.length > 0
                      ? Number(peopleList[0]?.currentCountry?.lat)
                      : Number(userDetails?.currentCountry?.lat),
                  lng:
                    peopleList.length > 0
                      ? Number(peopleList[0]?.currentCountry?.lng)
                      : Number(userDetails?.currentCountry?.lng),
                }}
                defaultZoom={10}
                yesIWantToUseGoogleMapApiInternals
                onGoogleApiLoaded={({ map }) => {
                  mapRef.current = map;
                }}
                onChange={({ zoom, bounds }) => {
                  setZoom(zoom);
                  setBounds([
                    bounds.nw.lng,
                    bounds.se.lat,
                    bounds.se.lng,
                    bounds.nw.lat,
                  ]);
                }}
              >
                {clusters.map((cluster) => {
                  const [longitude, latitude] = cluster.geometry.coordinates;
                  const { cluster: isCluster, point_count: pointCount } =
                    cluster.properties;

                  if (isCluster) {
                    return (
                      <Marker key={cluster.id} lat={latitude} lng={longitude}>
                        <ClusterContainer>
                          <h2>{pointCount} users</h2>
                        </ClusterContainer>
                      </Marker>
                    );
                  }
                  return (
                    <Marker
                      key={cluster.properties.crimeId}
                      lat={latitude}
                      lng={longitude}
                    >
                      <ClusterContainer
                        onClick={() => {
                          +cluster?.properties?.info?.crime?.id !==
                            +userDetails?.id && setOpen(true);
                          setPersonInfo(cluster?.properties?.info?.crime);
                          console.log(
                            "person info",
                            cluster?.properties?.info?.crime
                          );
                        }}
                        style={{ background: "blue" }}
                      >
                        {cluster?.properties?.photo ? (
                          <img
                            src={cluster?.properties?.photo}
                            alt={cluster.properties.crimeId}
                          />
                        ) : (
                          <Avatar
                            size={{ xs: 20, xl: 20 }}
                            icon={<UserOutlined />}
                          />
                        )}
                        {/* <h2>single user</h2> */}
                      </ClusterContainer>
                    </Marker>
                  );
                })}
                {/* {crimes.map((crime: any) => (
                                <Marker key={crime.id} lat={crime.location.latitude} lng={crime.location.longitude}>
                                    <div style={{ background: "blue" }}>
                                        yo
                                    </div>
                                </Marker>
                            ))} */}
              </GoogleMapReact>{" "}
            </FilterContainer>
            {/* ) : ( */}

            {/* <FilterContainer
              style={{ background: "none", padding: "0", boxShadow: "none" }}
            >
              <div>Some lists</div>
            </FilterContainer> */}
            {/* )} */}
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 9 }}>
            <FilterContainer>
              <div style={{ width: "100%", height: "100%", overflowY: "auto" }}>
                {singlePerson}
              </div>
              {peopleList?.length > 0 && (
                <Pagination
                  style={{ marginBottom: "10vh" }}
                  current={currentPage}
                  total={allPages}
                  pageSize={1}
                  defaultPageSize={allPages}
                  showSizeChanger={false}
                  itemRender={itemRender}
                  showTotal={(total) => `Total: ${total} list`}
                />
              )}
            </FilterContainer>
            {/* <FilterContainer>
            <div>
              <h3>Filter people by:</h3>
              <br />
              <Label>
                <h3>Country</h3>
              </Label>
              <DropDown
                values={options}
                onChange={(e) => setCountry(e.target.value)}
              />
              <Label style={{ marginTop: "10px" }}>
                <h3>City</h3>
              </Label>
              <TextInput
                placeholder="Type city/state name here..."
                onChange={(e: any) => setCity(e.target.value)}
              />
              <br />
              <LoggerButton
                loading={loadingstate}
                onClick={() => handlePeopleSearch(country, city)}
                text="Filter"
              />
            </div>
          </FilterContainer> */}
          </Col>
        </Row>
      )}
    </BigContentContainer>
  );
};

export default People;
export const Text = styled.h4`
  color: ${(props) => props.theme.color};
`;
